import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { appConfig } from "../../owner.config";
import { FeatureFlagModel } from "../models/feature-flag.model";

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagsService {
  constructor(private http: HttpClient) { }

  private get headers(): HttpHeaders {
    const token = localStorage.getItem('token');
    return token
      ? new HttpHeaders().set('Authorization', `Bearer ${token}`)
      : new HttpHeaders();
  }

  getFeatureFlagTeleAdvice(): Observable<FeatureFlagModel> {
    const url = `${appConfig.apiUrl}FeatureFlags/TeleAdvice`;
    return this.http.get<FeatureFlagModel>(url, { headers: this.headers });
  }

  getFeatureFlagHillsPostAdoptionDTC(): Observable<FeatureFlagModel> {
    const url = `${appConfig.apiUrl}FeatureFlags/HillsPostAdoptionDTC`;
    return this.http.get<FeatureFlagModel>(url, { headers: this.headers });
  }

  getFeatureFlagInsurance(): Observable<FeatureFlagModel> {
    const url = `${appConfig.apiUrl}FeatureFlags/Insurance`;
    return this.http.get<FeatureFlagModel>(url, { headers: this.headers });
  }
}
